<template>
<div>
  <div class="my-5 container card_container">
    <div class="mb-5 titolo">
      <h3 class="text-green mt-5 text-center"><i class="fas fa-clipboard-list"></i> Agenda</h3>
    </div>
    <b-row>
      <b-col cols="12">
        <label for="input-calendar-agenda" class="active">Seleziona una data</label>
        <b-form-datepicker id="input-calendar-agenda" size="sm" v-model="dataInizioRicerca" @input="loadAppuntamenti"></b-form-datepicker>
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col xs="12" sm="12" md="10" lg="10" xl="10" class="mt-2">
				<b-form-input id="input-filter-agenda" type="text" v-model="filterTableAgenda" placeholder="Cerca nell'agenda"></b-form-input>
      </b-col>
			<b-col xs="12" sm="12" md="2" lg="2" xl="2" class="text-center mt-2">
				<b-button variant="outline-primary" class="mb-5" @click="onStampaLista" v-b-modal.pdfmodel><i class="fas fa-print"></i> Stampa lista</b-button>
			</b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col cols="12">
        <b-table sticky-header ref="tableAgenda" responsive stacked="lg" striped hover :filter="filterTableAgenda" :items="appuntamenti" :fields="fieldsAppuntamenti" :current-page="tableAgendaCurrentPage" :per-page="tableAgendaPerPage" head-variant="light" show-empty empty-text="Non ci sono appuntamenti in agenda">
          <template #empty="scope">
            <h6 class="text-center">{{scope.emptyText}}</h6>
          </template>
        </b-table>
      </b-col>
      <b-col cols="12">
        <b-pagination v-model="tableAgendaCurrentPage" :total-rows="tableAgendaTotalItems" :per-page="tableAgendaPerPage" align="right" size="sm"></b-pagination>
      </b-col>
    </b-row>
  </div>
  <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" color="#00388C" loader="dots" :height="120" :width="120"></loading>
	<pdf-viewer :title="titoloModalPrenotati" :pdf="pdfAgenda"></pdf-viewer>
</div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Agenda from '@/services/operatore/Agenda';
import {DateTime} from "luxon";
import pdfViewer from '@/components/pdfViewer/pdfViewer.vue';


export default {
  components: {
		pdfViewer,
    Loading,
  },
  data() {
    return {
      appuntamenti: [],
      fieldsAppuntamenti: [
        {
          label: 'Nome',
          key: 'titolo',
          sortable: true
        },
        {
          label: 'Identificativo',
          key: 'identificativoAppuntamento',
          sortable: true
        },
        {
          label: 'Attività',
          key: 'descrizionePrestazione'
        },
        {
          label: 'Orario di inizio',
          key: 'dataOraInizio',
          formatter: value => DateTime.fromMillis(value).toFormat('HH:mm'),
          filterByFormatted: true,
          sortable: true
        },
        {
          label: 'Orario di fine',
          key: 'dataOraFine',
          formatter: value => DateTime.fromMillis(value).toFormat('HH:mm'),
          filterByFormatted: true
        }
      ],
			pdfAgenda: null,
			titoloModalPrenotati: '',
      filterTableAgenda: '',
      dataInizioRicerca: DateTime.local().toFormat('yyyy-MM-dd'),
      tableAgendaCurrentPage: 1,
      tableAgendaPerPage: 10,
      tableAgendaTotalItems: 0,
      tokenLogin: null,
      isLoading: false
    }
  },
  mounted: function () {
    this.tokenLogin = sessionStorage.getItem("loginData");
    if (this.tokenLogin != null)
      this.loadAppuntamenti();
  },
  methods: {
    loadAppuntamenti() {
      let me = this;
      const validValue = DateTime.fromFormat(me.dataInizioRicerca, 'yyyy-MM-dd').isValid;
      if (!validValue)
        return;
      me.isLoading = true;
      Agenda.getAppuntamenti(process.env.VUE_APP_CODICE_STRUTTURA, me.dataInizioRicerca)
        .then(response => {
          if (!response.data.error) {
            me.appuntamenti = response.data.data;
            me.tableAgendaTotalItems = response.data.data.length;
          } else {
            this.$bvModal.msgBoxOk(response.data.msg, {
              title: "Errore " + response.data.error,
              size: "sm",
              okVariant: "outline-danger",
              headerClass: "vv-msg-header-danger",
              footerClass: "p-2 border-top-0",
              centered: true,
              okTitle: "Chiudi",
            })
              .then(() => {})
              .catch();
          }
        })
        .catch()
        .finally(() => me.isLoading = false);
    },
		onStampaLista() {
			let me = this;
			me.isLoading = true;
			Agenda.printPrenotati(process.env.VUE_APP_CODICE_STRUTTURA, me.dataInizioRicerca)
				.then(response => {
					const dataRicerca = DateTime.fromFormat(me.dataInizioRicerca, 'yyyy-MM-dd');
					me.titoloModalPrenotati = `Elenco prenotati del ${dataRicerca.toFormat('dd-MM-yyyy')}`;
					me.pdfAgenda = response.data.data;
				})
				.catch()
				.finally(() => me.isLoading = false);
		}
  }
}

</script>

<style scoped>

</style>
